import { nutritionFormAdapter } from "../form-adapter";
export const nutNutritionAdapter = nutritionFormAdapter("nut");
